import { Typography, Box } from "@mui/material";
import styled from "@emotion/styled";
import {
  BookingDataConsistencyStatusEnum,
  BookingTypeEnum,
  InvestmentQuoteNotationEnum,
  InvestmentTypeEnum,
} from "@rentablo/api/apiv1";

export interface TableBookingData {
  id: number;
  valueDate: string;
  bookingType: BookingTypeEnum;
  numberOfLots: number;
  securityPrice: number;
  priceChange: number | null;
  expenses: number;
  amount: number;
  grossGain: number | null;
  isExternalID: boolean;
  comment?: string;
  currency?: string;
  investmentId: number;
  investmentType: InvestmentTypeEnum;
  quoteNotation?: InvestmentQuoteNotationEnum;
  dataConsistencyStatus?: BookingDataConsistencyStatusEnum;
  isCancelled: boolean;
}

interface TypographyColoredProps {
  lots: number;
}

export const TypographyColored = styled(Typography)<TypographyColoredProps>`
  color: ${({ theme, lots }) => {
    if (lots < 0) return theme.palette.text.negative;
    return theme.palette.text.positive;
  }};
`;

export const ValueDateWrapper = styled(Box)`
  display: flex;
  align-items: center;
`;
